<template>
  <div class="isoftware">
      <div class="layer">
        <div class="title">多角色分层</div>
        <div class="write">
            无论是管理员、代理、商家；<br/>
            系统按角色分层，精心设计，满足不同角色的一切需求
        </div>
        <div class="port">
            <img src="./images/computer.png" alt="电脑">
        </div>
    </div>

    <!-- 多维度统计数据 -->
    <div class="sdata">
        <div class="title">多维度统计数据</div>
        <div class="write">
            实时掌握运营情况，便于商家及时调整运营策略
        </div>
        <div class="port"><img src="./images/phone.png" alt="手机" ></div>
        <div class="count">
            <div class="total"><div class="circle"><img src="./images/01.png" alt="" ></div><div class="word">收益统计</div></div>
            <div class="total"><div class="circle"><img src="./images/02.png" alt=""></div><div class="word">分类收入</div></div>
            <div class="total"><div class="circle"><img src="./images/03.png" alt=""></div><div class="word">门店数据</div></div>
            <div class="total"><div class="circle"><img src="./images/04.png" alt=""></div><div class="word">会员数据</div></div>
            <div class="total"><div class="circle"><img src="./images/05.png" alt=""></div><div class="word">成本数据</div></div>
            <div class="total"><div class="circle"><img src="./images/06.png" alt=""></div><div class="word">盈利趋势</div></div>                    
        </div>
    </div>

    <!-- 完善crm -->
    <div class="crm">
        <div class="title">完善CRM模块</div>
        <div class="write">
            无论是游客还是会员，支持多种筛选条件<br/>
            助你精准定位、了解核心用户
        </div>
        <div class="port">
            <img src="./images/phone1.png" alt="手机">
        </div>
    </div>

    <!-- 更多功能 -->
    <div class="function">
        <div class="title">更多功能</div>
        <div class="write">
            更多实用功能，等待您的体验
        </div>
        <div class="port">
            <div class="list_items">
                <div class="list_item" @click="off1 = !off1"><div class="icons"><span class="icon"></span><p>后台管理系统</p></div> </div>
                <div class="list_item" @click="off2 = !off2"> <div class="icons"><span class="icon"></span><p>资金安全保障</p></div></div>
                <div class="list_item" @click="off3 = !off3"> <div class="icons"><span class="icon"></span><p>消息推送功能</p></div></div>
                <div class="list_item" @click="off4 = !off4">  <div class="icons"><span class="icon"></span><p>会员卡功能</p></div></div>
                <div class="list_item" @click="off5 = !off5">  <div class="icons"><span class="icon"></span><p>自动分账功能</p></div></div>
                <div class="list_item" @click="off6 = !off6"> <div class="icons"><span class="icon"></span><p>公众号吸粉功能</p></div></div>
               
            </div>
        </div>
        <div class="back-stage" :class="{push:off1}">
            <div class="close"><img src="../../assets/phone/close.svg" alt="" @click="off1 = !off1"></div>
             <div class="back-item" >
                <div class="back-title">后台管理系统</div>
                <div class="back-write">免费后台管理系统、代理、商家、子账号分管功能，轻松管理账目，多种财务报表，随时随地查看订单和机器运营的情况</div>
                <div class="line"></div>
            </div>
        </div>
        <div class="back-stage" :class="{push:off2}">
            <div class="close"><img src="../../assets/phone/close.svg" alt="" @click="off2 = !off2"></div>
             <div class="back-item" >
                <div class="back-title">资金安全保障</div>
                <div class="back-write">维码器与腾讯、支付宝、兴业银行汇丰商务全面战略合作，维码器系统直接调用银行和腾讯、支付宝接口、多方对账实现零误差，100%保障资金安全</div>
                <div class="line"></div>
            </div>
        </div>
        <div class="back-stage" :class="{push:off3}">
            <div class="close"><img src="../../assets/phone/close.svg" alt="" @click="off3 = !off3"></div>
             <div class="back-item" >
                <div class="back-title">消息推送功能</div>
                <div class="back-write">订单支付，设备异常，订单异常，礼品数量不足，消费者提交申诉等系统主动推送消息至商家微信</div>
                <div class="line"></div>
            </div>
        </div>
        <div class="back-stage" :class="{push:off4}">
            <div class="close"><img src="../../assets/phone/close.svg" alt="" @click="off4 = !off4"></div>
             <div class="back-item" >
                <div class="back-title">会员卡功能</div>
                <div class="back-write">虚拟会员卡功能，帮助商家快速回笼资金，可设置充值优惠，吸引并留住客户</div>
                <div class="line"></div>
            </div>
        </div>
        <div class="back-stage" :class="{push:off5}">
            <div class="close"><img src="../../assets/phone/close.svg" alt="" @click="off5 = !off5"></div>
             <div class="back-item" >
                <div class="back-title">自动分账功能</div>
                <div class="back-write">系统将自动按比例分账配套子账号共同查账对账功能，轻松解决合伙人分账困难繁琐等问题</div>
                <div class="line"></div>
            </div>
        </div>
        <div class="back-stage" :class="{push:off6}">
            <div class="close"><img src="../../assets/phone/close.svg" alt="" @click="off6 = !off6"></div>
             <div class="back-item" >
                <div class="back-title">公众号吸粉功能</div>
                <div class="back-write">每个商家都可设置关注公众号赠币营销活动，服务号，订阅号均可</div>
                <div class="line"></div>
            </div>
        </div>
    </div>

    <!-- 底部 -->
    <foot></foot>
  </div>
</template>

<script>
import Foot from '../hardProduct/foot'
export default {
  name:"Isoftware",
  components:{Foot},
  data(){
    return{
      lists:[
        {title:'后台管理系统',content:'免费后台管理系统、代理、商家、子账号分管功能，轻松管理账目，多种财务报表，随时随地查看订单和机器运营的情况'},
        {title:'资金安全保障',content:'维码器与腾讯、支付宝、兴业银行汇丰商务全面战略合作，维码器系统直接调用银行和腾讯、支付宝接口、多方对账实现零误差，100%保障资金安全'},
        {title:'消息推送功能',content:'订单支付，设备异常，订单异常，礼品数量不足，消费者提交申诉等系统主动推送消息至商家微信'},
        {title:'会员卡功能',content:'虚拟会员卡功能，帮助商家快速回笼资金，可设置充值优惠，吸引并留住客户'},
        {title:'自动分账功能',content:'系统将自动按比例分账配套子账号共同查账对账功能，轻松解决合伙人分账困难繁琐等问题'},
        {title:'公众号吸粉功能',content:'每个商家都可设置关注公众号赠币营销活动，服务号，订阅号均可'},
      ],
      cur:0,
     off1:false,
     off2:false,
     off3:false,
     off4:false,
     off5:false,
     off6:false,
    }
  },
  methods:{
      show(index){
          this.off = !this.off;
      }
  }
}
</script>

<style scoped>
.isoftware{
    margin-top: 48px;
}
.layer{
    width: 100%;
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
background: #fafafa;
}
.layer .title{
font-size: 22px;
line-height: 22px;
letter-spacing: 2px;
margin-top:50px;
color: #333333;
}
.layer .write{
font-size: 12px;
color: #999999;
margin-top:25px;
text-align: center;
    line-height: 16px;
}
.layer .port{
width: 80%;
margin-top:50px;
}
.layer .port img{
    width: 100%;
}

/* 多维度统计数据 */
.sdata{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.sdata .title{
   font-size: 22px;
   line-height: 22px;
letter-spacing: 2px;
margin-top:50px;
color: #333333;
}
.sdata .write{
font-size: 12px;
line-height: 12px;
color: #999999;
margin-top:25px;
text-align: center;
}
.sdata .count{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80%;
    height: 160px;
    flex-wrap: wrap;
    margin-bottom: 50px;
}
.sdata .port{
width: 70%;
margin-top:50px;
}
.sdata .port img{
    width: 100%;
}
.sdata .total{
    width: 30%;
    height: 63px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
}
.sdata .circle{
    width: 40px;
	height: 40px;
	border: solid 1px #cccccc;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center
}
.sdata .circle img{
    width: 17px;
    height: 17px;
}
.sdata .circle:hover{
    border: 2px solid #198bfe;
}
.sdata .word{
    font-size: 12px;
    line-height: 12px;
	letter-spacing: 0px;
	color: #333333;
}
/* 完善crm */
.crm{
    width: 100%;
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
background: #fafafa;
}
.crm .title,.function .title{
font-size: 22px;
line-height: 22px;
letter-spacing: 2px;
margin-top:50px;
color: #333333;
}
.crm .write,.function .write{
font-size: 12px;
line-height: 14px;
color: #999999;
margin-top:25px;
text-align: center;
}
.crm .port{
width: 80%;
margin-top:50px;
}
.crm .port img{
    width: 100%;
}
 /* 更多功能  */
 .function{
    width: 100%;
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
}
.function .port{
        width: 100%;
    margin: 50px 0px;
}
.port .list_items{
    padding: 0px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
   
}
.port .list_items .list_item{
    width: 47%;
    height: 85px;
    background: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
     margin-bottom: 15px;
    border-radius: 10px;
}
.list_item .icons{
        display: flex;
    flex-direction: column;
    align-items: center;
}
.list_item .icons p{
    font-size: 12px;
    color: #333;
    margin-top: 10px;
    font-weight: bold;
}
.list_item .icons .icon{
    display: block; 
    width: 25px;
    height: 25px;
    
}
.list_item:nth-child(1) .icons .icon{
    background: url(./images/phone/01-01.png) no-repeat;
    background-size: cover;
}
.list_item:nth-child(2) .icons .icon{
    background: url(./images/phone/02-01.png) no-repeat;
    background-size: cover;
}
.list_item:nth-child(3) .icons .icon{
    background: url(./images/phone/03-01.png) no-repeat;
    background-size: cover;
}
.list_item:nth-child(4) .icons .icon{
    background: url(./images/phone/04-01.png) no-repeat;
    background-size: cover;
}
.list_item:nth-child(5) .icons .icon{
    background: url(./images/phone/05-01.png) no-repeat;
    background-size: cover;
}
.list_item:nth-child(6) .icons .icon{
    background: url(./images/phone/06-01.png) no-repeat;
    background-size: cover;
}
.function .back-stage{
    width: 100%;
    height: 100vh;
    background: #000;
    transition: all 0.15s linear;
    opacity: 0;
    position: fixed;
    top: 0;
    z-index: -1;
}
.function .back-stage.push{
    transition: opacity 0.15s linear;
    opacity: 1;
    z-index: 99;
}
.back-stage .close{
    width: 100%;
    height: 48px;
    padding: 0px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .back-stage .back-item{
      height: calc(100vh - 48px);
        display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 0px 32px;
    box-sizing: border-box;
    text-align: center;
  }
 .back-stage .close img{
    width: 15px;
	  height: 15px;
  }
  .back-item .back-title{
      font-size: 17px;
      color: #fff;
      margin-top: 50px;
      font-weight: bold;
  }
  .back-item .back-write{
      font-size: 13px;
      color: #fff;
      margin-top: 29px;
  }
  .back-item .line{
      width: 29px;
	height: 2px;
	background-color: #198bfe;
	border-radius: 1px;
     margin-top: 30px;
  }
</style>





// WEBPACK FOOTER //
// src/components/software/Isoftware.vue